import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Box: {
    borderRadius: '12px',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
  },
  Modal: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  BoxHeader: {
    display: 'flex',
    alignItems: 'start',
    padding: ' 20px 16px 16px 16px',
    justifyContent: 'space-between',
    gap: '12px',
  },
  BoxContent: {
    display: 'flex',
    padding: '0px 16px',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
  },
  BoxFooter: {
    display: 'flex',
    padding: ' 24px 16px 16px 16px',
    alignItems: 'flex-start',
    gap: '12px',
    flex: '1 0 0',
  },
  TitleModal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  Icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
  },
  Items: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    borderRadius: '12px',
    border: '1px solid var(--Gray-200, #EAECF0)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    padding: '16px',
    gap: '24px',
  },
  BoxZone: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'start',
  },
}));

const cancelButtonStyle = {
  display: 'flex',
  padding: '12px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Gray-300, #D0D5DD)',
  background: 'var(--Base-White, #FFF)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: '#FFF' },
};

const confirmButtonStyle = {
  display: 'flex',
  padding: '12px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Primary-600, #30893C)',
  background: 'var(--Primary-600, #30893C)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: '#30893C' },
};

export { useStyles, confirmButtonStyle, cancelButtonStyle };
